import { useEffect } from 'react'
import axios from 'axios'
import { API, isTestUrl } from '../utils'
import { UserAuthorizationService } from '../service'

export function useCheckLogin() {
  useEffect(() => {
    const instance = axios.create({
      withCredentials: true,
      baseURL:
        process.env.NODE_ENV === 'development'
          ? '/'
          : isTestUrl()
            ? API.auth.testHost
            : API.auth.host,
    })

    // 检查登录状态
    const checkLoginStatus = () => {
      instance
        .post(API.auth.queryUser)
        .then((res) => {
          if (res.status === 200 && res.data.code === 200 && res.data.data.userName) {
            if (!UserAuthorizationService.isLogined()) {
              UserAuthorizationService.setUserName(res.data.data.userName)
              UserAuthorizationService.setUserId(res.data.data.userId)
            }
          } else {
            if (UserAuthorizationService.isLogined()) {
              UserAuthorizationService.removeUserName()
              UserAuthorizationService.removeUserId()
            }
          }
        })
        .catch(console.error)
    }

    checkLoginStatus()

    // 监听页面可见性变化（用户切换标签页回来时）
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkLoginStatus()
      }
    }

    // 监听窗口获得焦点（用户从其他窗口返回时）
    const handleFocus = () => {
      checkLoginStatus()
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    window.addEventListener('focus', handleFocus)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      window.removeEventListener('focus', handleFocus)
    }
  }, [])
}
